import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import router from './routes';
import Filters from './components/Filters.vue';
import VehicleResult from './components/VehicleResult.vue';
import NewVehicleData from '../new-vue/store/modules/new-vehicle-data';
import CustomerData from '../used-vue/store/modules/customer-data';
import Layout from '../new-vue/store/modules/layout';
import Valuations from '../new-vue/store/modules/valuations';
import BusinessResults from './store/business-results';
import GetMetaDataFromRoute from './modules/GetMetaDataFromRoute';
import { customEvent, generateLeadEvent, trackPageView } from '../modules/tracking/AnalyticsEvents';
import LiveChatClass from '../live-chat/modules/live-chat-class';
import LocationDataLoader from '../modules/LocationDataLoader';
import GoogleMapsLoaderClass from '../modules/GoogleMapsLoader';

require('../cookie-warning.js');
require('../assign-general-functions-to-window.js');

window.liveChatClass = new LiveChatClass;
window.LocationDataLoader = new LocationDataLoader;
window.customerLat = getCookieValue('lat');
window.customerLng = getCookieValue('lng');
window.customerPostcode = getCookieValue('postcode');
window.customerGeolocation = getCookieValue('geolocation');
// Create a global object for getting a new Google Maps instance
window.GoogleMapsLoader = new GoogleMapsLoaderClass;
// Handle detecting when Google Maps has finished loading
window.googleMapsLoaded = () => {
    window.GoogleMapsLoader.mapLoaded();
};

setTimeout(() => {
    liveChatClass.initLiveChat((typeof liveChatLocationId !== 'undefined') ? liveChatLocationId : false);
}, 500);

Vue.use(Vuex);
Vue.use(VueRouter);

Vue.mixin({
    methods: {
        gaTag(eventCategory = '', eventAction = '', eventLabel = '') {
            customEvent(eventCategory, eventAction, eventLabel, 0);
        },
        generateLeadEvent(name = 'Misc Event', value = 0, currency = 'GBP') {
            generateLeadEvent(name, currency, value);
        },
        trackPageView() {
            trackPageView();
        }
    }
});

const bodyEl = document.body;
const metaDescription = document.querySelector('meta[name="description"]');
const titleEl = document.querySelector('title');
const canonicalEl = document.querySelector('link[rel="canonical"]');
let firstLoad = true;

router.afterEach((to, from) => {
    // Helper function to get meta data from the route. Some routes have the brand as a param in the URL
    // This helper function changes the "meta" data based on the brand if applicable
    const metaDataForRoute = GetMetaDataFromRoute(to);
    if (metaDataForRoute.brand) {
        store.commit('Layout/setBrand', metaDataForRoute.brand);
    } else {
        store.commit('Layout/setBrand', 'randd');
    }

    // Update the page title
    if (store.getters['BusinessResults/seoTitle'] != null) {
        titleEl.innerHTML = store.getters['BusinessResults/seoTitle'];
    } else if (metaDataForRoute.title) {
        titleEl.innerHTML = metaDataForRoute.title;
    }

    if (store.getters['BusinessResults/seoDescription'] != null) {
        metaDescription.setAttribute('content', store.getters['BusinessResults/seoDescription']);
    } else if (metaDataForRoute.desc) {
        metaDescription.setAttribute('content', metaDataForRoute.desc);
    }

    // Campaign
    // Reset the form back to not completed so the customer can fill in again
    // store.commit('CampaignStore/setCompleted', false);

    if (metaDataForRoute.searchPage) {
        store.commit('BusinessResults/setLastResultsUrl', to);
    }

    canonicalEl.setAttribute('href', 'https://www.stellantisandyou.co.uk' + to.path);

    // Send Page View event
    if (firstLoad) {
        firstLoad = false;
    } else {
        trackPageView(location.pathname, titleEl.innerHTML);
    }

    let classes = [
        // store.state.Layout.brand,
    ];
    if (metaDataForRoute.bodyClasses) {
        for (let i = 0, len = metaDataForRoute.bodyClasses.length; i < len; i += 1) {
            classes.push(metaDataForRoute.bodyClasses[i]);
        }
    }
    let toRemove = [];
    // Remove classes that aren't listed in const classes
    for (let i = 0, len = bodyEl.classList.length; i < len; i += 1) {
        if (classes.indexOf(bodyEl.classList[i]) == -1) {
            toRemove.push(bodyEl.classList[i]);
        }
    }

    for (let i = 0, len = toRemove.length; i < len; i += 1) {
        bodyEl.classList.remove(toRemove[i]);
    }

    for (let i = 0, len = classes.length; i < len; i += 1) {
        bodyEl.classList.add(classes[i]);
    }
});

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const debug = process.env.NODE_ENV !== 'production';

router.afterEach((to, from) => {
    if (typeof liveChatClass !== 'undefined') {
        liveChatClass.setCustomerType('New');
    }
});

const store = new Vuex.Store({
    modules: {
        NewVehicleData,
        CustomerData,
        Layout,
        Valuations,
        BusinessResults,
    },
    strict: debug,
    state: {
        // expose router for store navigation (used by BusinessResults)
        __router: null,
        loading: true,
        vehicleId: null,
        vehicle: null,
        selectedPaintOption: null,
    },
    actions: {
        getVehicleData({ commit, state }) {
            commit('setVehicle', null);
            commit('enableLoadingState');

            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/business/vehicle/${state.vehicleId}`)
                    .then((response) => {
                        const vehicle = response.data.vehicle;
                        const seo = response.data.seo;

                        commit('setVehicle', vehicle);

                        if (seo.title) {
                            titleEl.innerHTML = seo.title;
                        }else{
                            titleEl.innerHTML = `${ vehicle.manufacturer} ${vehicle.model} ${vehicle.version} | Stellantis &You UK Fleet & Business`;
                        }

                        if (seo.description) {
                            metaDescription.setAttribute(
                                'content',
                                seo.description
                            );
                        }
                        resolve({ data: response.data.vehicle, instant: false });
                        commit('disableLoadingState');
                    })
                    .catch((error) => {
                        console.error('Error getting vehicle data', error);
                        commit('setVehicle', null);
                        titleEl.innerHTML = 'Vehicle Not Found | Stellantis &You UK Fleet & Business';
                        reject();
                        commit('disableLoadingState');
                    });
            });
        },
    },
    getters: {
        vehicle(state) {
            return state.vehicle;
        },
        selectedPaintOption(state) {
            return state.selectedPaintOption;
        },
        getVehicleId(state) {
            return state.vehicle.id;
        },
    },
    mutations: {
        setRouter(state, router) {
            state.__router = router;
        },
        setInitialFilters(state, initialFilters) {
            state.initialFilters = initialFilters;
        },
        setScopedFilters(state, scopedFilters) {
            state.scopedFilters = scopedFilters;
        },
        setActiveFilters(state, activeFilters) {
            state.activeFilters = activeFilters;

            Object.keys(state.activeFilters).forEach((key) => setQueryParameter(key, state.activeFilters[key]));
        },
        setVehicleId(state, vehicleId) {
            state.vehicleId = vehicleId;
        },
        setVehicle(state, vehicle) {
            state.vehicle = vehicle;
        },
        setSelectedPaintOption(state, paint) {
            state.selectedPaintOption = paint;
        },
        enableLoadingState(state) {
            state.loading = true;
        },
        disableLoadingState(state) {
            state.loading = false;
        },
    },
});

new Vue({
    el: '#app',
    data: {
        brand: 'randd',
    },
    store,
    router,
    created() {
        // Initialize shared modules and hydrate business filters from the URL
        this.$store.dispatch('CustomerData/initialize');
        this.$store.dispatch('Layout/initialize');
    },
    components: {
        Filters,
        VehicleResult,
    },
});
